import { useEffect, useState } from 'react';
import { SectionTitle } from '@/components';
import { Box, Checkbox, FormGroup, FormControlLabel, Stack, Typography } from '@mui/material';
import { AdImageData, AdMediaType } from '@/types';
import { Gallery } from '@/components/PdfManager/Gallery';
import styles from '@/components/uiComponents/FormCheckbox/FormCheckbox.module.scss';

export const GalleryBlock = ({
  image,
  updateSelectedImages,
}: {
  image: AdImageData;
  updateSelectedImages: (id: string, selectedImages: AdMediaType[]) => void;
}) => {
  const { id, name, images } = image;
  const [checked, setChecked] = useState(false);
  const [countSelectedImages, setCountSelectedImages] = useState(0);
  const [selectionState, setSelectionState] = useState({ selectAll: false });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setSelectionState({ selectAll: isChecked });
    setCountSelectedImages(isChecked ? images.length : 0);
    // updateSelectedImageCounts(id, count, image);
  };

  useEffect(() => {
    setChecked(countSelectedImages === images.length);
  }, [countSelectedImages, images.length]);

  useEffect(() => {
    // Только выбранные
    const selected = selectionState.selectAll ? images : images.slice(0, countSelectedImages); // если пользователь вручную выбирал

    updateSelectedImages(id, selected);
  }, [selectionState.selectAll, countSelectedImages]);

  return (
    <Stack
      alignItems='flex-start'
      spacing={2}
      sx={{
        backgroundColor: '#F1F7FF',
        borderRadius: '20px',
        marginTop: '10px',
        padding: '20px',
      }}
    >
      <Box display='flex' width='100%' flexDirection='column' gap={2}>
        <SectionTitle variant='blank' title={name} />
        <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap'>
          <Typography component='label'>
            There are {images.length >= 4 ? '4' : '3'} images available for selection that you can
            display in your collection
          </Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  checkedIcon={<span className={styles.checked} />}
                  inputProps={{ 'aria-label': 'controlled' }}
                  icon={<span />}
                  onChange={handleChange}
                />
              }
              label='Select all'
            />
          </FormGroup>
        </Box>
        <Gallery
          images={images}
          selectionState={selectionState}
          countSelectedImages={countSelectedImages}
          setCountSelectedImages={setCountSelectedImages}
        />
      </Box>
    </Stack>
  );
};
